/* eslint-disable no-fallthrough */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
// import { putErrorNotification } from '@wix/da-shared-react/pkg/utils/saga';
import { request, isApiError } from '../../xhr';
// import { ConfigSelectors } from '@wix/da-shared-react/pkg/config';
import ddt from '@wix/da-ddt';
import { updateModule, fetchModuleEndpoint, fetchModuleEndpointSuccess, fetchModuleEndpointError, fetchModuleSuccess } from '../actions/modules';
import { getModuleVersion } from '../selectors/modules';
// deviation_gruser TODO: use from the lib
const configReduxKey = '@@config';
const getConfigKey = (name)=>(state)=>{
        var _state_configReduxKey;
        return (_state_configReduxKey = state[configReduxKey]) === null || _state_configReduxKey === void 0 ? void 0 : _state_configReduxKey[name];
    };
function* postModuleEndpoint(endpoint, params) {
    return yield call(request, {
        method: 'post',
        url: `/gruser/module/${endpoint}`,
        data: params
    });
}
function* getModuleEndpoint(endpoint, params) {
    return yield call(request, {
        method: 'get',
        url: `/gruser/module/${endpoint}`,
        params
    });
}
const isModuleResponse = (response)=>response && response.hasOwnProperty('id') && response.hasOwnProperty('version') && response.hasOwnProperty('moduleData');
export function* runModuleInitActions(gruser, moduleResponse) {
    // Duck typing
    if (!isModuleResponse(moduleResponse)) {
        return;
    }
    yield put(fetchModuleSuccess(gruser, moduleResponse));
}
export function* fetchModuleEndpointSaga(action) {
    var _action;
    const _ref = ((_action = action) === null || _action === void 0 ? void 0 : _action.payload) || {}, { gruser } = _ref, payload = _object_without_properties(_ref, [
        "gruser"
    ]);
    const { id, path, method } = payload, data = _object_without_properties(payload, [
        "id",
        "path",
        "method"
    ]);
    const version = yield select(getModuleVersion, gruser, id);
    const { gruserId, gruserTypeid, gruserItemid } = gruser;
    const csrf = yield select(getConfigKey('csrfToken'));
    const fetchEndpoint = method === 'get' ? getModuleEndpoint : postModuleEndpoint;
    const response = yield call(fetchEndpoint, path, _object_spread_props(_object_spread({}, data), {
        csrf_token: csrf,
        version,
        gruserid: gruserId,
        gruser_typeid: gruserTypeid,
        gruser_itemid: gruserItemid,
        moduleid: id
    }));
    if (!response || isApiError(response)) {
        var _response_errorDetails, _response, _response1, _response2;
        const errorDescription = ((_response = response) === null || _response === void 0 ? void 0 : (_response_errorDetails = _response.errorDetails) === null || _response_errorDetails === void 0 ? void 0 : _response_errorDetails.Form) || ((_response1 = response) === null || _response1 === void 0 ? void 0 : _response1.details) || ((_response2 = response) === null || _response2 === void 0 ? void 0 : _response2.errorDescription);
        ddt.log(`modules`, `fetch action error`, `${errorDescription}`);
        // yield putErrorNotification(errorDescription);
        yield put(fetchModuleEndpointError(gruser, {
            id,
            path,
            errorDescription
        }));
        yield put(updateModule(gruser, {
            id,
            moduleMeta: {
                isFetching: false
            }
        }));
        return;
    }
    if (isModuleResponse(response)) {
        // update module data in the store
        yield runModuleInitActions(gruser, response);
    } else {
        // endpoint does not return a module response, hence, no module version gets updated
        // module version is used as memoization key for many hooks, so if no version
        ddt.log(`modules`, `save endpoint does not return a module response`, {
            id,
            path,
            response
        });
    }
    yield put(fetchModuleEndpointSuccess(gruser, {
        id,
        response,
        path
    }));
}
export default function* rootModulesSaga() {
    yield all([
        takeEvery(fetchModuleEndpoint, fetchModuleEndpointSaga)
    ]);
}
